export default {"src":"/_next/static/media/logo-powered-by-autopass-outline.862e408a.svg","height":15,"width":109,"blurWidth":0,"blurHeight":0};